import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as inventoryApi from '../../lib/api/inventory';


const [LIST_INV_STOCKS, LIST_INV_STOCKS_SUCCESS, LIST_INV_STOCKS_FAILURE] =
    createRequestActionTypes('inventory/LIST_INV_STOCKS');
export const listInventoryStocks = createAction(
    LIST_INV_STOCKS,
    (searchData) => searchData,
);
const listInventoryStocksSaga = createRequestSaga(
    LIST_INV_STOCKS,
    inventoryApi.getInventoryStocks,
);

const UNLOAD_INV_STOCKS = 'inventory/UNLOAD_INV_STOCKS';
export const unloadInventoryStocks = createAction(UNLOAD_INV_STOCKS);

export function* invStocksSaga() {
    yield takeLatest(LIST_INV_STOCKS, listInventoryStocksSaga);
}

const initialState = {
    stocks: null,
    error: null,
};

const invStocks = handleActions(
    {

        [LIST_INV_STOCKS_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            stocks: data.list.map((stock) => ({
                id: stock.stockUuid,
                stockUuid: stock.stockUuid,
                whUuid: stock.whUuid,
                productUuid: stock.productUuid,
                productNm: stock.productNm,
                category: stock.category,
                modelNm: stock.modelNm,
                masPartnerNm: stock.masPartnerNm,//제조업체
                pricePartnerNm: stock.pricePartnerNm,//매입처(구매처)
                trnUuid: stock.trnUuid,
                trnDesc: stock.trnDesc,
                priceUuid: stock.priceUuid,
                productCnt: stock.productCnt,
                priceVal: stock.priceVal,
                crtUsrNm: stock.crtUsrNm,
                crtDt: stock.crtDt,
            })),
            error: null,
        }),
        [LIST_INV_STOCKS_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
        [UNLOAD_INV_STOCKS]: () => initialState
    },
    initialState,
);

export default invStocks;
